import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {showAuthenticationPopup, setAuthenticationPopupShowSignupPanel} from '../actions/common';
import LoginForm from './account/auth-popup-form/LoginForm';
import SignupForm from './account/auth-popup-form/SignupForm';
import ForgotPasswordForm from './form/ForgotPasswordForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AuthenticationPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // showSignup: false,
            forgotPasswordVisible: false,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.authenticated === false && this.props.authenticated === true) {
            this.props.showAuthenticationPopup(false);
        }
        if (!_.isEqual(prevProps.match, this.props.match)) {
            this.props.showAuthenticationPopup(false);
        }
    }

    render() {
        const {visible, showSignup, authenticated} = this.props;
        // const {showSignup} = this.state;
        if (visible && !authenticated) {
            return (
                <div className="bt-popup-backdrop">
                    <div className="bt-popup bt-popup-authentication container">
                        <div className="container" onClick={(e) => e.stopPropagation()}>
                            <label className="btn-close" onClick={() => this.props.showAuthenticationPopup(false)} style={{zIndex: 1}}><FontAwesomeIcon icon={["fal", "times"]} style={{height: "16px", width: "16px"}} /></label>
                            <div className="row">
                                <div className={`col-12 ${showSignup? "d-none": "d-flex"}`}>
                                    <h4>เข้าสู่ระบบ</h4>
                                    <LoginForm showSignup={(v) => {this.setState({showSignup: v})}} onForgotClick={() => this.setState({forgotPasswordVisible: true})} />
                                    <div className="d-block g-mt-10"><span onClick={() => this.props.setAuthenticationPopupShowSignupPanel('signup')}>ยังไม่สมัครสมาชิก <span className="click-here">คลิกที่นี่ค่ะ</span></span></div>
                                </div>
                                <div className={`col-12 ${showSignup? "d-flex": "d-none"}`}>
                                    <h4>สมัครสมาชิก</h4>
                                    <SignupForm showSignup={(v) => {this.setState({showSignup: v})}} />
                                    <div className="d-block g-mt-10"><span onClick={() => this.props.setAuthenticationPopupShowSignupPanel('login')}>เป็นสมาชิกอยู่แล้ว <span className="click-here">คลิกที่นี่ค่ะ</span></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.forgotPasswordVisible && <ForgotPasswordForm closePopup={() => {this.setState({forgotPasswordVisible: false})}}/> }
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        visible: state.common.show_login,
        showSignup: state.common.authPopupPanel === 'signup',
    }
}
export default connect(mapStateToProps, {showAuthenticationPopup, setAuthenticationPopupShowSignupPanel})(AuthenticationPopup)